// extracted by mini-css-extract-plugin
module.exports = {"footer":"PoFooter_footer__29bhd"};